import { render, staticRenderFns } from "./DrugTargetAnalysis.vue?vue&type=template&id=c3830670&scoped=true"
import script from "./DrugTargetAnalysis.vue?vue&type=script&lang=js"
export * from "./DrugTargetAnalysis.vue?vue&type=script&lang=js"
import style0 from "./DrugTargetAnalysis.vue?vue&type=style&index=0&id=c3830670&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3830670",
  null
  
)

export default component.exports